import { Button, RobotIcon, CloseIcon } from "@fluentui/react-northstar";
import { useChatStore } from "../../stores/useChatStore";
import Yeetchicon from "../../assets/chatbot/Yeetchi v2.svg";
import { FloatingDockPortal } from "../FloatingDock/FloatingDock";

const buttonStyle = {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
};

const ChatbotButton = () => {
    const { isOpen, toggleChat } = useChatStore();

    return (
        <FloatingDockPortal slot="chatbot">
            <Button
                id="chatbot-toggle-button"
                circular
                primary
                // icon={isOpen ? <CloseIcon /> : <RobotIcon size="large" />}
                icon={
                    isOpen ? (
                        <CloseIcon />
                    ) : (
                        <img
                            src={Yeetchicon}
                            alt="Yeetch Icon"
                            style={{ width: 43, height: 43 }}
                        />
                    )
                }
                onClick={(e) => {
                    e.preventDefault();
                    toggleChat();
                }}
                aria-label="Toggle chat"
                styles={buttonStyle}
            />
        </FloatingDockPortal>
    );
};

export default ChatbotButton;
